// services/humanizeRelativeTime.js

export default function humanizeRelativeTime(date, now = Date.now()) {
  if (!date) return 'Nunca actualizado'

  const elapsedSeconds = Math.max(0, Math.floor((now - new Date(date).getTime()) / 1000))

  if (elapsedSeconds < 10) return 'hace unos segundos'
  if (elapsedSeconds < 60) return `hace ${elapsedSeconds} segundos`

  const elapsedMinutes = Math.floor(elapsedSeconds / 60)
  if (elapsedMinutes < 60) return `hace ${elapsedMinutes} ${elapsedMinutes === 1 ? 'minuto' : 'minutos'}`

  const elapsedHours = Math.floor(elapsedMinutes / 60)
  if (elapsedHours < 24) return `hace ${elapsedHours} ${elapsedHours === 1 ? 'hora' : 'horas'}`

  const elapsedDays = Math.floor(elapsedHours / 24)
  return `hace ${elapsedDays} ${elapsedDays === 1 ? 'día' : 'días'}`
}
